import { razorpay_vendor } from "../../js/path";
import _ from "lodash";

export default {
  data() {
    return {
        businessTypes: [
            "llp","ngo","other","individual","partnership","proprietorship","public_limited","private_limited","trust, society","not_yet_registered","educational_institutes",
        ],
        // categories: ["financial_services", "education", "healthcare", "utilities", "government", "logistics", "tours_and_travel", "transport", "ecommerce", "food", "it_and_software", "gaming", "media_and_entertainment", "services", "housing", "not_for_profit", "social", "others"],  
        // subcategories: ["clinic", "school", "store", "freelancer"],
        categories: [
            { value: "healthcare", text: "Healthcare" },
            { value: "education", text: "Education" },
            { value: "government", text: "Government" }
          ],
          subcategoryMapping: {
            healthcare: [
              { value: "pharmacy", text: "Pharmacy" },
              { value: "clinic", text: "Clinic" },
              { value: "hospital", text: "Hospital" },
              { value: "lab", text: "Lab" },
              { value: "dietician", text: "Dietician" },
              { value: "fitness", text: "Fitness" },
              { value: "health_coaching", text: "Health Coaching" },
              { value: "health_products", text: "Health Products" },
              { value: "drug_stores", text: "Drug Stores" },
              { value: "healthcare_marketplace", text: "Healthcare Marketplace" },
              { value: "osteopaths", text: "Osteopaths" },
              { value: "medical_equipment_and_supply_stores", text: "Medical Equipment and Supply Stores" },
              { value: "podiatrists_and_chiropodists", text: "Podiatrists and Chiropodists" },
              { value: "dentists_and_orthodontists", text: "Dentists and Orthodontists" },
              { value: "hardware_stores", text: "Hardware Stores" },
              { value: "ophthalmologists", text: "Ophthalmologists" },
              { value: "orthopedic_goods_stores", text: "Orthopedic Goods Stores" },
              { value: "testing_laboratories", text: "Testing Laboratories" },
              { value: "doctors", text: "Doctors" },
              { value: "health_practitioners_medical_services", text: "Health Practitioners (Medical Services)" }
            ],
            education: [
              { value: "college", text: "College" },
              { value: "schools", text: "Schools" },
              { value: "university", text: "University" },
              { value: "professional_courses", text: "Professional Courses" },
              { value: "distance_learning", text: "Distance Learning" },
              { value: "day_care", text: "Day Care" },
              { value: "coaching", text: "Coaching" },
              { value: "elearning", text: "Elearning" },
              { value: "vocational_and_trade_schools", text: "Vocational and Trade Schools" },
              { value: "sporting_clubs", text: "Sporting Clubs" },
              { value: "dance_halls_studios_and_schools", text: "Dance Halls, Studios and Schools" },
              { value: "correspondence_schools", text: "Correspondence Schools" }
            ],
            government: [
              { value: "central", text: "Central" },
              { value: "state", text: "State" },
              { value: "intra_government_purchases", text: "Intra Government Purchases" },
              { value: "goverment_postal_services", text: "Postal Services" }
            ]
          },
        form: {
            email: "",
            phone: "",
            legal_business_name: "",
            customer_facing_business_name: "",
            business_type: "",
            reference_id: "",
            split_value: "",
            split_type: "",
      
            profile: {
              category: "",
              subcategory: "",
              business_model: ""
            },
      
            addresses: {
              registered: {
                address_line1: "",
                address_line2: "",
                city: "",
                state: "",
                country: "",
                pincode: ""
              },
              operation: {
                address_line1: "",
                address_line2: "",
                city: "",
                state: "",
                country: "",
                pincode: ""
              }
            },
      
            legal_info: {
              business_pan: "",
              gst: ""
            }
          },
          form1: {
            addresses: {
              residential: {
                address_line1: "",
                address_line2: "",
                city: "",
                state: "",
                postal_code: "",
              }
            },
      
            kyc: {
              owner_pan: ""
            },
          },
          productConfig: {
            settlements: {
              account_number: "",
              ifsc_code: "",
              beneficiary_name: ""
            },
            tnc_accepted: false
          },
          form2: {
            active_configuration: {
              settlements: {
                account_number: "",
                beneficiary_name: "",
                ifsc_code: ""
              }
            },
            tnc: {
              id: "",
              accepted: false,
              accepted_at: ""
            }
          },
      pageNo: null,
      table_header: [],
      razorpay_vendor_id: null,
      loadingId: null,
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "member_name",
          label: "Doctor Name",
        },
        {
            key: "account_id",
            label: "Link Account Id",
        },
        {
          key: "stakeholder_id",
          label: "Stakeholder Id",
        },
        {
            key: "account_product_id",
            label: "Product Id",
        },
        {
            key: "is_account",
            label: "Link Account Status",
        },
        {
            key: "is_stakeholder",
            label: "Stakeholder Status",
        },
        {
            key: "is_tnc",
            label: "Terms & Conditions",
        },
        {
            key: "is_active",
            label: "Active",
        },
        {
          key: "gen_plan_status",
          label: "Action",
        },
      ],
      oldForm: {},
      params: "",
      filter: null,
      filterOn: [],
      tableData: [],
      sortBy: "id",
      sortDesc: true,
      key: 0,
      activeTab: "all",
      currentPage: 1,
      firstLoad: false,
      isEditingPreview: false,
      selectedFiles: [],
      imageFiles: [],
      pdfFiles: [],
      chatList: [],
    };
  },
  computed: {
    filteredSubcategories() {
      return this.subcategoryMapping[this.form.profile.category] || [];
    },
  },  
  methods: {
    search(event) {
      if (this.filter.length > 1) {
        if (event.keyCode == 13) {
          this.fetchData(this.activeTab);
        }
      } else if (this.filter.length == 0) this.fetchData(this.activeTab);
    },
    searchFor() {
      if (this.filter.length > 0) {
        this.fetchData(this.activeTab);
      } else {
        this.fetchData(this.activeTab);
      }
    },
    filterPage() {
      if (this.pageNo.length > 0) {
        this.params = `&page=${this.pageNo}`;
        this.fetchData(this.activeTab);
        this.currentPage = this.pageNo;
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async fetchData(txt) {
      let url = null;
      if (txt == "active") {
        this.activeTab = txt;
        if (this.filter != null && this.filter != "") {
          url = razorpay_vendor.razorpay_vendorUrl + "?filter=" + txt + "&search=" + this.filter;
        } else {
          url = razorpay_vendor.razorpay_vendorUrl + "?filter=" + txt;
        }
      } else if (txt == "trash") {
        this.activeTab = txt;
        if (this.filter != null && this.filter != "") {
          url = razorpay_vendor.razorpay_vendorUrl + "?filter=" + txt + "&search=" + this.filter;
        } else {
          url = razorpay_vendor.razorpay_vendorUrl + "?filter=" + txt;
        }
      } else if (txt == "all") {
        this.activeTab = txt;
        if (this.filter != null && this.filter != "") {
          url = razorpay_vendor.razorpay_vendorUrl + "?filter=" + txt + "&search=" + this.filter;
        } else {
          url = razorpay_vendor.razorpay_vendorUrl + "?filter=" + txt;
        }
      }
      url += this.params;
      this.$store.commit("loader/updateStatus", true);
      try {
        const data = await this.getRequest(url);
        if (data.status) {
          const responseData = data.response;
          this.tableData = responseData;
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
      this.$store.commit("loader/updateStatus", false);
      this.key += 1;
    },

    async fetchDietPlan(id) {
      this.$store.commit("loader/updateStatus", true);
      let url = razorpay_vendor.razorpay_vendorUrl + "/" + id;
      const data = await this.getRequest(url);
      if (data.status) {
        const responseData = data.response;
        this.razorpay_vendor_id = responseData.id;

        if (responseData.html != "" && responseData.html != null) {
          this.form.html = responseData.html;
        }

        this.edit.html = responseData.html;

        this.oldForm = _.clone(this.form);
      }

      this.$store.commit("loader/updateStatus", false);
    },
    cleanHTML(html) {
      return html
        .replace(/<div><br><\/div>/g, "")
        .replace(/<div>\s*<\/div>/g, "")
        .replace(/<p><br><\/p>/g, "")
        .replace(/&nbsp;/g, " ");
    },

    onEdit() {
      let cleaned = this.cleanHTML(this.$refs.editor.innerHTML);
      this.form.html = cleaned;
    },

    onTextareaEdit() {
      if (!this.isEditingPreview) {
        this.$refs.editor.innerHTML = this.form.html;
      }
    },

    async updateStatus(id) {
      try {
        let index = this.tableData.data.findIndex((e) => e.id === id);
        const url = razorpay_vendor.updateStatus + "/" + id;
        const data = await this.postRequest(url, {
          is_active: !this.tableData.data[index].is_active,
        });
        if (data.status) {
          console.log(data);
          const responseData = data.response
          this.tableData.data[index] = responseData;
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });
        }
        this.key += 1;
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
    },

    async generatePdf(record) {
      console.log("generating PDF:", record.id);

      try {
        const payload = {
          html: record.html,
          transaction_id: record.id,
        };

        console.log("PAYLOAD:", payload);

        const url = razorpay_vendor.generatePdf;
        console.log("PDF URL:", url);

        const response = await this.postRequest(url, payload);
        console.log("Response wow:", response);

        if (response.status) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: response.message,
          });
        }
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      } finally {
        this.loadingId = null;
      }
    },

    async updateLinkedAccount() {
      try {
        this.submitted = true;
    
        // If using Vuelidate
        if (this.$v) {
          this.$v.$touch();
          if (this.$v.$invalid) return;
        }
    
        // Show loader
        this.$store.commit("loader/updateStatus", {
          status: true,
          message: "Updating linked account...",
        });
    
        // API URL
        const url = `${razorpay_vendor.generareSpiltAccountUrl}/update/${this.form.selectedAccountId}`;
    
        // Create raw JSON object (NOT FormData)
        // because Razorpay + your backend expects JSON
        const payload = {
          legal_business_name: this.form.legal_business_name,
    
          street1: this.form.addresses.registered.address_line1,
          street2: this.form.addresses.registered.address_line2,
          city: this.form.addresses.registered.city,
          state: this.form.addresses.registered.state,
          postal_code: this.form.addresses.registered.pincode,
          split_value: this.form.split_value,
          split_type: this.form.split_type,
          business_type: this.form.business_type,
          
    
          // Always India
          country: "IN",
    
          // Legal info
          business_pan: this.form.business_pan || null,
          gst: this.form.gst || null,
        };
    
        console.log("UPDATE LINKED ACCOUNT PAYLOAD:", payload);
    
        // PATCH request using postRequest (method override)
        const data = await this.postRequest(url, {
          ...payload,
          _method: "PATCH"
        });
    
        if (data.status) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: "Linked account updated successfully!",
          });
    
          // Hide modal
          this.$bvModal.hide("update-linked-account");
    
          // Refresh list if needed
          if (this.getAccounts) {
            this.getAccounts();
          }
        }
    
      } catch (err) {
        console.error("UPDATE LINKED ACCOUNT ERROR:", err);
    
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err?.data?.message || "Update failed. Please try again!",
        });
      }
    
      // Hide loader always
      this.$store.commit("loader/updateStatus", false);
    },

    async updateStakeholder() {
      try {
        this.submitted = true;
    
        // Vuelidate validation
        if (this.$v) {
          this.$v.$touch();
          if (this.$v.$invalid) return;
        }
    
        // Loader ON
        this.$store.commit("loader/updateStatus", {
          status: true,
          message: "Updating stakeholder information...",
        });
    
        // API URL
        const url = `${razorpay_vendor.generareSpiltAccountUrl}/${this.form1.account_id}/stakeholders/${this.form1.stakeholder_id}`;
    
        // ---- Prepare payload for backend ----
        const payload = {
    
          // Address mapped as per backend formatting
          member_id: this.form1.member_id,
          street1: this.form1.addresses.residential.address_line1,
          street2: this.form1.addresses.residential.address_line2,
          city: this.form1.addresses.residential.city,
          state: this.form1.addresses.residential.state,
          postal_code: this.form1.addresses.residential.postal_code,
          country: "IN",
    
          // PAN
          owner_pan: this.form1.kyc.owner_pan || null,
    
          // Laravel method override
          _method: "PATCH",
        };
    
        console.log("STAKEHOLDER UPDATE PAYLOAD:", payload);
    
        // ---- API CALL ----
        const data = await this.postRequest(url, payload);
    
        if (data.status) {
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: "Stakeholder updated successfully!",
          });
    
          // Hide modal
          this.$bvModal.hide("update-stakeholder-modal");
    
          // Refresh listing
          if (this.getAccounts) this.getAccounts();
        }
    
      } catch (err) {
        console.error("UPDATE STAKEHOLDER ERROR:", err);
    
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err?.data?.message || "Stakeholder update failed!",
        });
      }
    
      // Loader OFF
      this.$store.commit("loader/updateStatus", false);
    },
    
    allowOnlyText(e) {
      const char = String.fromCharCode(e.keyCode);
  
      // Allow only alphabets (a-zA-Z) and space
      if (!/^[a-zA-Z ]$/.test(char)) {
        e.preventDefault();
      }
    },
    allowOnlyNumbers(e) {
      const char = String.fromCharCode(e.keyCode);
  
      // Allow only digits 0–9
      if (!/^[0-9]$/.test(char)) {
        e.preventDefault();
      }
    },
    allowDecimal(e) {
      const char = String.fromCharCode(e.keyCode);
  
      // Allow digits
      if (/^[0-9]$/.test(char)) {
        return;
      }
  
      // Allow ONE decimal point
      if (char === "." && !e.target.value.includes(".")) {
        return;
      }
  
      // Block everything else
      e.preventDefault();
    },
  
    allowDecimalPaste(e) {
      const paste = e.clipboardData.getData("text");
  
      // Allow only numbers and at most one dot
      if (!/^\d*\.?\d*$/.test(paste)) {
        e.preventDefault();
      }
    },
    

    async submitData() {
      try {
        this.submitted = true;
        this.$v.$touch();

        // default loader before API submit
        this.$store.commit("loader/updateStatus", {
          status: true,
          message: "Submitting data...",
        });

        let url = razorpay_vendor.razorpay_vendorUrl + "/" + this.razorpay_vendor_id;

        let dataAppend = new FormData();
        dataAppend.append("_method", "PATCH");
        if (this.form.html) dataAppend.append("html", this.form.html);

        const data = await this.postRequest(url, dataAppend);

        if (data.status) {
          // 🔥 Show loader while generating new PDF
          this.$store.commit("loader/updateStatus", {
            status: true,
            message: "Generating new plan...",
          });

          await this.generatePdf(data.response);

          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });

          this.$router.push("/diet-plan");
        }
      } catch (err) {
        console.log(err);
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }

      this.$store.commit("loader/updateStatus", false);
    },

    async fetchRazorpay_vendor(id) {
      this.$store.commit("toast/updateStatus", true);
      try {
        let url = razorpay_vendor.razorpay_vendorUrl + "/" + id;
        const data = await this.getRequest(url);
        if (data.status) {
          const responseData = data.response;
          this.razorpay_vendor_id = responseData.id;
        }
      } catch (err) {
        console.log(err);
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: "Fetching error!",
        });
      }
      this.$store.commit("toast/updateStatus", false);
    },
    // tabActive() {
    //   if (!this.can("edit-diet-plan")) {
    //     let index = this.fields.findIndex((item) => item.key == "edit");
    //     if (index !== -1) {
    //       this.fields.splice(index, 1);
    //       let table_index = this.table_header.findIndex(
    //         (item) => item == "edit"
    //       );
    //       this.table_header.splice(table_index, 1);
    //     }
    //   } else {
    //     if (!this.table_header.includes("edit")) {
    //       this.table_header.push("edit");
    //       this.fields[6] = {
    //         key: "edit",
    //       };
    //     }
    //   }
    // }, 
    async updateApproveStatus(id) {
      try {
        let index = this.tableData.data.findIndex((e) => e.id === id);
        const url = razorpay_vendor.updateApproveStatus + "/" + id;
    
        const newStatus =
          this.tableData.data[index].is_approved == 1 ? 0 : 1;
    
        const data = await this.postRequest(url, {
          is_approved: newStatus,
        });
    
        if (data.status) {
          this.tableData.data[index] = data.response;
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "success",
            title: data.message,
          });
        }
    
        this.key += 1;
      } catch (err) {
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: err.data ? err.data.message : "Please try again!",
        });
      }
    },
    openModal1(itemArray) {
      console.log("openModal:", itemArray);

    //   const fileItem = itemArray.find(i => i.file && i.file.length > 0);

    //   if (!fileItem) {
    //     this.imageFiles = [];
    //     this.pdfFiles = [];
    //     this.selectedFiles = [];
    //     this.$bvModal.show("document-modal");
    //     return;
    //   }

    //   // file is an array of URL strings
    //   this.selectedFiles = fileItem.file;
    //   this.imageFiles = this.selectedFiles.filter(f => this.isImage(f));
    //   this.pdfFiles = this.selectedFiles.filter(f => this.isPdf(f));

      this.$bvModal.show("update-linked-account");
    },

    async openLinkAccountModal(id) {
      // console.log("openModal:", id);
    
      // Show loader toast ON
      
    
      try {
        this.form.selectedAccountId = id;
        const url = `${razorpay_vendor.generareSpiltAccountUrl}/${id}`;
        const data = await this.getRequest(url);
console.log(data);
this.$store.commit("toast/updateStatus", { status: true });
        const r = data?.response;

        // Remove +91 from phone
        const cleanPhone = (num) => {
          if (!num) return "";
          return num.startsWith("+91") ? num.replace("+91", "") : num;
        };        

    this.form = {
      ...this.form,
    
      email: r?.email ?? "",
      phone: cleanPhone(r?.phone),
      legal_business_name: r?.legal_business_name ?? "",
      customer_facing_business_name: r?.customer_facing_business_name ?? "",
      business_type: r?.business_type ?? "",
      reference_id: r?.id ?? "",
      split_value: r?.split_value ?? "",
      split_type: r?.split_type ?? "",
    
      profile: {
        category: r?.profile?.category ?? "",
        subcategory: r?.profile?.subcategory ?? "",
        business_model: r?.profile?.business_model ?? ""
      },
    
      addresses: {
        registered: {
          address_line1: r?.profile?.addresses?.registered?.street1 ?? "",
          address_line2: r?.profile?.addresses?.registered?.street2 ?? "",
          city: r?.profile?.addresses?.registered?.city ?? "",
          state: r?.profile?.addresses?.registered?.state ?? "",
          country: r?.profile?.addresses?.registered?.country ?? "",
          pincode: r?.profile?.addresses?.registered?.postal_code ?? ""
        },
    
        operation: {
          address_line1: r?.profile?.addresses?.registered?.street1 ?? "",
          address_line2: r?.profile?.addresses?.registered?.street2 ?? "",
          city: r?.profile?.addresses?.registered?.city ?? "",
          state: r?.profile?.addresses?.registered?.state ?? "",
          country: r?.profile?.addresses?.registered?.country ?? "",
          pincode: r?.profile?.addresses?.registered?.postal_code ?? ""
        }
      },
    
      // legal_info: {
      //   business_pan: r?.legal_info?.pan ?? "",
      //   gst: r?.legal_info?.gst ?? ""
      // }
      business_pan: r?.legal_info?.pan ?? "",
      gst: r?.legal_info?.gst ?? "",

    };
    console.log(this.form);
    
      } catch (err) {
        console.log(err);
    
        this.$store.commit("toast/updateStatus", {
          status: true,
          icon: "error",
          title: "Fetching error!"
        });
      } finally {
        // Hide loader toast AFTER all async work is done
        this.$store.commit("toast/updateStatus", { status: false });
      }
    
      // Open modal after completing everything
      this.$bvModal.show("update-linked-account");
    },
    

    // openChatModal(member_id,id,stakeholder_id) {
    //   this.form1.member_id = member_id;
    //   this.form1.account_id = id;
    //   this.form1.stakeholder_id = stakeholder_id;
    //   this.$bvModal.show("update-stakeholder-modal");
    // },

//     openChatModal(member_id, account_id, stakeholder_id) {
//       this.form1.member_id = member_id;
//       this.form1.account_id = account_id;
//       this.form1.stakeholder_id = stakeholder_id;

//       const url = `${razorpay_vendor.generareSpiltAccountUrl}/${account_id}`;
//         const data = await this.getRequest(url);
// console.log(data);
// this.$store.commit("toast/updateStatus", { status: true });
//         const r = data?.response;

//         // Remove +91 from phone
//         const cleanPhone = (num) => {
//           if (!num) return "";
//           return num.startsWith("+91") ? num.replace("+91", "") : num;
//         };        

//     this.form = {
//       ...this.form,
    
//       email: r?.email ?? "",
//       phone: cleanPhone(r?.phone),
//       legal_business_name: r?.legal_business_name ?? "",
//       customer_facing_business_name: r?.customer_facing_business_name ?? "",
//       business_type: r?.business_type ?? "",
//       reference_id: r?.id ?? "",
//       split_value: r?.split_value ?? "",
//       split_type: r?.split_type ?? "",
    
//       profile: {
//         category: r?.profile?.category ?? "",
//         subcategory: r?.profile?.subcategory ?? "",
//         business_model: r?.profile?.business_model ?? ""
//       },
    
//       addresses: {
//         registered: {
//           address_line1: r?.profile?.addresses?.registered?.street1 ?? "",
//           address_line2: r?.profile?.addresses?.registered?.street2 ?? "",
//           city: r?.profile?.addresses?.registered?.city ?? "",
//           state: r?.profile?.addresses?.registered?.state ?? "",
//           country: r?.profile?.addresses?.registered?.country ?? "",
//           pincode: r?.profile?.addresses?.registered?.postal_code ?? ""
//         },
    
//         operation: {
//           address_line1: r?.profile?.addresses?.registered?.street1 ?? "",
//           address_line2: r?.profile?.addresses?.registered?.street2 ?? "",
//           city: r?.profile?.addresses?.registered?.city ?? "",
//           state: r?.profile?.addresses?.registered?.state ?? "",
//           country: r?.profile?.addresses?.registered?.country ?? "",
//           pincode: r?.profile?.addresses?.registered?.postal_code ?? ""
//         }
//       },
    
//       // legal_info: {
//       //   business_pan: r?.legal_info?.pan ?? "",
//       //   gst: r?.legal_info?.gst ?? ""
//       // }
//       business_pan: r?.legal_info?.pan ?? "",
//       gst: r?.legal_info?.gst ?? "",
    
//       // DEBUG
//       console.log("REGISTERED FORM:", this.form.addresses.registered);
    
//       // ✔ Correct assignment
//       this.form1.addresses.residential.address_line1 =
//         this.form.addresses.registered.address_line1 ?? "";
    
//       this.form1.addresses.residential.address_line2 =
//         this.form.addresses.registered.address_line2 ?? "";
    
//       this.form1.addresses.residential.city =
//         this.form.addresses.registered.city ?? "";
    
//       this.form1.addresses.residential.state =
//         this.form.addresses.registered.state ?? "";
    
//       this.form1.addresses.residential.postal_code =
//         this.form.addresses.registered.pincode ?? "";
//         // OR .postal_code — depending on what you saved
    
//       this.$bvModal.show("update-stakeholder-modal");
//     },


async openChatModal(member_id, account_id, stakeholder_id) {
  this.form1.member_id = member_id;
  this.form1.account_id = account_id;
  this.form1.stakeholder_id = stakeholder_id;

  try {
    const url = `${razorpay_vendor.generareSpiltAccountUrl}/${account_id}`;
    const data = await this.getRequest(url);
    const r = data?.response;

    const cleanPhone = (num) => {
      if (!num) return "";
      return num.startsWith("+91") ? num.replace("+91", "") : num;
    };

    // 1️⃣ UPDATE LINKED ACCOUNT FORM
    this.form = {
      ...this.form,

      // email: r?.email ?? "",
      phone: cleanPhone(r?.phone),
      legal_business_name: r?.legal_business_name ?? "",
      customer_facing_business_name: r?.customer_facing_business_name ?? "",
      business_type: r?.business_type ?? "",
      reference_id: r?.id ?? "",
      split_value: r?.split_value ?? "",
      split_type: r?.split_type ?? "",

      profile: {
        category: r?.profile?.category ?? "",
        subcategory: r?.profile?.subcategory ?? "",
        business_model: r?.profile?.business_model ?? ""
      },

      addresses: {
        registered: {
          address_line1: r?.profile?.addresses?.registered?.street1 ?? "",
          address_line2: r?.profile?.addresses?.registered?.street2 ?? "",
          city: r?.profile?.addresses?.registered?.city ?? "",
          state: r?.profile?.addresses?.registered?.state ?? "",
          country: r?.profile?.addresses?.registered?.country ?? "",
          pincode: r?.profile?.addresses?.registered?.postal_code ?? ""
        }
      },

      business_pan: r?.legal_info?.pan ?? "",
      gst: r?.legal_info?.gst ?? "",
    };

    // 2️⃣ ASSIGN TO STAKEHOLDER FORM
    console.log("REGISTERED FORM:", this.form.business_pan);

    this.form1.addresses.residential.address_line1 =
      this.form.addresses.registered.address_line1;

    this.form1.addresses.residential.address_line2 =
      this.form.addresses.registered.address_line2;

    this.form1.addresses.residential.city =
      this.form.addresses.registered.city;

    this.form1.addresses.residential.state =
      this.form.addresses.registered.state;

    this.form1.addresses.residential.postal_code =
      this.form.addresses.registered.pincode;

    // 3️⃣ OPEN MODAL
    this.$bvModal.show("update-stakeholder-modal");
  } catch (err) {
    console.error(err);
  }
},

    async updateProductConfig(member_id,id,prductId) {
        // Add API call here
    console.log(member_id,id,prductId);
    
        try {
          this.form2.member_id = member_id;
          this.form2.account_id = id;
          this.form2.account_product_id = prductId;
          const url = `${razorpay_vendor.generareSpiltAccountUrl}/${id}/products/${prductId}`;
          const data = await this.getRequest(url);
          const u = data?.response;        
  console.log(u);
  
      this.form2 = {
        ...this.form2,
      
        active_configuration: {
          settlements: {
            account_number: u?.active_configuration?.settlements?.account_number ?? "",
            beneficiary_name: u?.active_configuration?.settlements?.beneficiary_name ?? "",
            ifsc_code: u?.active_configuration?.settlements?.ifsc_code ?? ""
          }
        },
        tnc: {
          accepted: u?.tnc?.accepted ?? false
        }
      };
      
        } catch (err) {
          console.log(err);
      
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: "Fetching error!"
          });
        } finally {
          // Hide loader toast AFTER all async work is done
          this.$store.commit("toast/updateStatus", { status: false });
        }
    
        this.$bvModal.show("updateProductConfigModal")
      },

      async submitProductConfig() {
        try {
          this.submitted = true;
      
          // If using Vuelidate
          if (this.$v) {
            this.$v.$touch();
            if (this.$v.$invalid) return;
          }
      
          // Loader before API submit
          this.$store.commit("loader/updateStatus", {
            status: true,
            message: "Updating product configuration...",
          });
      
          let url = `${razorpay_vendor.generareSpiltAccountUrl}/update/bank-details/${this.form2.account_id}/products/${this.form2.account_product_id}`;
          
          // Use FormData because backend expects request->account_number etc.
          let formData = new FormData();
          formData.append("member_id", this.form2.member_id);
          formData.append("account_number", this.form2.active_configuration.settlements.account_number);
          formData.append("ifsc_code", this.form2.active_configuration.settlements.ifsc_code);
          formData.append("beneficiary_name", this.form2.active_configuration.settlements.beneficiary_name);
          formData.append("tnc_accepted", this.form2.tnc.accepted ? 1 : 0);
      
          // PATCH request
          formData.append("_method", "PATCH");
      
          const data = await this.postRequest(url, formData);
      
          if (data.status) {
            this.$store.commit("toast/updateStatus", {
              status: true,
              icon: "success",
              title: "Product configuration updated successfully!",
            });
      
            // Close modal
            this.$bvModal.hide("updateProductConfigModal");
      
            // Optional: refresh your table/list
            if (this.getAccounts) {
              this.getAccounts();
            }
          }
        } catch (err) {
          console.log(err);
      
          this.$store.commit("toast/updateStatus", {
            status: true,
            icon: "error",
            title: err?.data?.message || "Update failed. Please try again!",
          });
        }
      
        // Hide loader
        this.$store.commit("loader/updateStatus", false);
      },
      
      

    addNote() {
        if (!this.form1.notes) {
          this.form1.notes = []
        }
      
        this.form1.notes.push({ key: "", value: "" })
      },
      
    
      removeNote(index) {
        this.form1.notes.splice(index, 1);
      },
    
      submitStakeholderUpdate() {
        const payload = {
          name: this.form1.name,
          email: this.form1.email,
          percentage_ownership: this.form1.percentage_ownership,
          relationship: this.form1.relationship,
          phone: this.form1.phone,
          addresses: {
            residential: this.form1.addresses.residential
          },
          kyc: this.form1.kyc,
          notes: Object.fromEntries(
            this.form1.notes.map((n) => [n.key, n.value])
          )
        };
    
        console.log("Final Stakeholder Update Payload:", payload);
    
        // axios.post('/api/razorpay/stakeholder/update', payload)
      },

    formatAnswer(answer) {
      // If answer is null or empty return ''
      if (!answer) return '';
    
      // If answer is already an array
      if (Array.isArray(answer)) {
        return answer.join(", ");
      }
    
      // If answer is a JSON string array → parse it
      if (typeof answer === "string" && answer.startsWith("[") && answer.endsWith("]")) {
        try {
          const parsed = JSON.parse(answer); // Convert string to array
          if (Array.isArray(parsed)) {
            return parsed.join(", ");
          }
        } catch (e) {
          console.warn("JSON parse failed:", answer);
        }
      }
    
      // Otherwise return as string
      return answer;
    },    

    isImage(url) {
      console.log(url, "in isImage");
      return /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
    },

    isPdf(url) {
      return /\.pdf$/i.test(url);
    },

    openFile(url) {
      window.open(url, "_blank");
    },
  },
  watch: {
    currentPage: {
      handler: function (value) {
        if (typeof value != undefined) {
          this.params = `&page=${value}`;
          this.fetchData(this.activeTab);
          this.pageNo = this.currentPage;
        }
      },
    },
    "form.html"(newVal) {
      if (!this.firstLoad && newVal) {
        this.$refs.editor.innerHTML = newVal;
        this.firstLoad = true;
      }
    },
    activeTab(v) {
      if (v) this.tabActive();
    },
  },
  mounted() {
    if (this.$route.name == "edit-diet-plan") {
      this.fetchDietPlan(this.$route.params.id);
    }
    this.tabActive();

    this.$refs.editor.innerHTML = this.form.html;
  },
  created() {
    this.fetchData(this.activeTab);
    this.fields.map((item) => {
      this.table_header.push(item.key);
    });
  },
};